import React from 'react';
import BundleSelection from "@app/react/components/BundleWizard/BundleSelection.jsx";
import BundleCart from "@app/react/components/BundleWizard/BundleCart.jsx";

export default function BundleWizard({collection, categories, bundles, defaultValue, discount}) {
  const [selectedBundle, setSelectedBundle] = React.useState(null);
  return <div className="bundle-wizard-container">
    <div className="d-flex flex-row align-items-center justify-content-between">
      <div className="bundle-header">
        <h1>{collection.title}</h1>
        <div>
            <span className="bundle-title">
              {selectedBundle &&  <>
                {selectedBundle.title} ({Drupal.tt('cod.')} {selectedBundle.sku})
              </>}
              &nbsp;
            </span>
        </div>
      </div>
      <div>
        {selectedBundle && <>
          <a href={Drupal.url('/bundle/'+selectedBundle.id+'/scheda-tecnica')} className="btn-dark btn-ico-download">{Drupal.tt("scheda tecnica")}</a>
        </>}
      </div>
    </div>
    <div className='row'>
      <div className='col-md-3'>
        <div className='bundle-image'>
          {!selectedBundle && <img src={collection.image} alt=''/>}
          {selectedBundle && <img src={selectedBundle.image} alt={selectedBundle.title}/>}
        </div>
        <div className='bundle-selection'>
          <BundleSelection defaultValue={defaultValue} categories={categories} bundles={bundles} onSelect={setSelectedBundle} />
        </div>
      </div>
      <div className='col-md-9'>
        <BundleCart bundle={selectedBundle} discount={discount} />
      </div>
    </div>
  </div>
}
